/* eslint-disable @typescript-eslint/no-explicit-any */

import { TAB_KEY } from '@portal/enum/onboardingType';
import { AccountStatus } from '@portal/models/enumerators';
import qs from 'qs';
import { history } from './browserHistory';

const NavigationService = {
  go: (
    to: string | number,
    options?: {
      replace?: boolean;
      state?: any;
      query?: Record<string, unknown>;
    }
  ) => {
    if (typeof to === 'number') {
      history.go(to);
      return;
    }

    const navigationMethod = options?.replace ? history.replace : history.push;

    const location: any = {
      pathname: to,
    };

    if (options?.query) {
      location.search = qs.stringify(options.query, { skipNulls: true });
    }

    if (options?.state) {
      location.state = options.state;
    }

    navigationMethod(location);
  },

  back: () => {
    history.go(-1);
  },

  getQuery: () => {
    let search = history.location.search;
    if (search[0] === '?') {
      search = search.substring(1);
    }

    return qs.parse(search);
  },

  navigate: (routeName: string, query?: any) => {
    history.push({
      pathname: routeName,
      search: qs.stringify(query, { skipNulls: true }),
    });
  },

  navigateWithState: (routeName: string, state?: any) => {
    history.push(routeName, state);
  },

  reset: (routeName: string, params?: any) => {
    history.push(routeName, params);
  },

  getOnboardingTab: (status: AccountStatus): TAB_KEY | undefined => {
    switch (status) {
      case AccountStatus.ERROR_TO_CREATE:
      case AccountStatus.REPROVED:
      case AccountStatus.BLOCKED:
      case AccountStatus.CANCELED:
        break;
      case AccountStatus.REQUESTED_ADDRESS:
        return TAB_KEY.ADDRESS;
      case AccountStatus.REQUESTED_SELF:
      case AccountStatus.REQUESTED_DOCUMENTS:
        return TAB_KEY.DOCUMENT;
      case AccountStatus.REQUESTED_PIN:
        return TAB_KEY.PIN;
      case AccountStatus.REQUESTED_PARTNERS:
        return TAB_KEY.NEW_REPRESENTANTS;
      case AccountStatus.REQUESTED_LEGAL_REPRESENTOR:
        return TAB_KEY.MINOR_REPRESENTANTS;
      case AccountStatus.REQUESTED_SELF_REPRESENTOR:
      case AccountStatus.REQUESTED_DOCUMENT_REPRESENTOR:
        return TAB_KEY.LEGAL_REPRESENTANTS_DOCUMENT;
      case AccountStatus.PENDING_DOCUMENTS:
      case AccountStatus.PENDING_CREATE_COREBANK_CONFIRM:
      case AccountStatus.PENDING_MANUAL_APPROVAL:
      case AccountStatus.PENDING_CREATE_COREBANK:
      case AccountStatus.PENDING_APPROVAL:
      case AccountStatus.PENDING_KYC_ANALYSIS:
      case AccountStatus.PENDING_KYC_APPROVE:
        return TAB_KEY.FINAL;
      default:
        break;
    }
  },
};

export default NavigationService;
